import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

// Need pluralization? See tutorial
// https://locize.com/blog/react-i18next/
export const i18nOptions = {
  debug: false,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: {
      translation: {
        legal:
          "By submitting, you agree to our <tosLink>terms of service</tosLink> and <ppLink>privacy policy</ppLink>.",
        powered_by:
          "{{assistant_name}} can make mistakes. Powered by <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Send a message",
        "suggestions.toggle.show": "Show suggestions",
        "suggestions.toggle.hide": "Hide suggestions",
        suggestions: "Suggestions",
        assistant: "Assistant",
        thinking: "Thinking",
        understanding: "Understanding Ask",

        "handoff.success": "Handoff successful",
        "handoff.check_email": "Check your email",
        "handoff.anything_else":
          "Is there anything else I can assist you with?",
        "handoff.rejected": "Handoff rejected",
        "handoff.edit": "Edit handoff",
        "handoff.validation.firstName_required": "First name is required",
        "handoff.validation.lastName_required": "Last name is required",
        "handoff.validation.subject_required": "Issue description is required",
        "handoff.validation.body_required": "Details are required",
        "handoff.validation.body_too_short":
          "Please provide more detailed information",
        "handoff.validation.email_required": "Email is required",
        "handoff.validation.email_invalid":
          "Please enter a valid email address",

        "handoff.form.issue_label": "Issue",
        "handoff.form.details_label": "Details",
        "handoff.form.firstName_label": "First Name",
        "handoff.form.lastName_label": "Last Name",
        "handoff.form.email_label": "Your Email",

        "handoff.form.firstName_placeholder": "Max",
        "handoff.form.lastName_placeholder": "Mustermann",
        "handoff.form.email_placeholder": "max@mustermann.de",

        "handoff.form.email_notice":
          "You receive a copy and we will follow up shortly.",
        "handoff.error.title": "Backend Error",

        "handoff.form.cancel_button": "Cancel",
        "handoff.form.send_button": "Send",
        "handoff.form.sending_button": "Sending",
        "conversations.title": "Conversations",
        "conversations.noConversationsYet": "No conversations yet",
        "conversations.tapToStart":
          "Tap 'Start Conversation' to begin interacting with the AI assistant",
        "conversations.startConversation": "Start Conversation",
        noConversationBranching:
          "This conversation is ongoing in another tab/window. Please await the completion before continuing here.",
        "whatsapp.title": "Reach us on WhatsApp",
        "whatsapp.instructions":
          "<bold>Click</bold> or <bold>Scan</bold> to open WhatsApp",
      },
    },
    de: {
      translation: {
        legal:
          "Durch das Absenden einer Nachricht erteilen Sie Zustimmung zu unseren <tosLink>Nutzungsbedingungen</tosLink> und <ppLink>Datenschutzrichtlinien</ppLink>.",
        powered_by:
          "{{assistant_name}} kann Fehler machen. Bereitgestellt von <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Eine Nachricht senden",
        "suggestions.toggle.show": "Vorschläge einblenden",
        "suggestions.toggle.hide": "Vorschläge ausblenden",
        suggestions: "Vorschläge",
        assistant: "Assistent",
        thinking: "Denken",
        understanding: "Anfrage verstehen",
        "handoff.success": "Weitergeleitet",
        "handoff.check_email": "Überprüfe Deine Mails",
        "handoff.anything_else": "Kann ich Dir noch bei etwas anderem helfen?",
        "handoff.rejected": "Weiterleitung abgelehnt",
        "handoff.edit": "Weiterleitung bearbeiten",
        "handoff.validation.firstName_required": "Vorname ist erforderlich",
        "handoff.validation.lastName_required": "Nachname ist erforderlich",
        "handoff.validation.subject_required":
          "Problembeschreibung ist erforderlich",
        "handoff.validation.body_required": "Details sind erforderlich",
        "handoff.validation.body_too_short":
          "Bitte gib ausführlichere Informationen an",
        "handoff.validation.email_required": "E-Mail ist erforderlich",
        "handoff.validation.email_invalid":
          "Bitte gib eine gültige E-Mail-Adresse ein",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Details",
        "handoff.form.firstName_label": "Vorname",
        "handoff.form.lastName_label": "Nachname",
        "handoff.form.email_label": "E-Mail Adresse",
        "handoff.form.firstName_placeholder": "Max",
        "handoff.form.lastName_placeholder": "Mustermann",
        "handoff.form.email_placeholder": "max@mustermann.de",
        "handoff.form.email_notice":
          "Du erhälst eine Kopie und wir melden uns in Kürze.",
        "handoff.error.title": "Backend-Fehler",
        "handoff.form.cancel_button": "Abbrechen",
        "handoff.form.send_button": "Senden",
        "handoff.form.sending_button": "Wird gesendet",
        "conversations.title": "Unterhaltungen",
        "conversations.noConversationsYet": "Noch keine Unterhaltung",
        "conversations.tapToStart":
          'Tippen Sie auf "Unterhaltung starten", um mit dem KI-Assistenten zu interagieren',
        "conversations.startConversation": "Unterhaltung starten",
        noConversationBranching:
          "Diese Unterhaltung läuft bereits in einem anderen Tab/Fenster. Bitte warten Sie, bis sie abgeschlossen ist, bevor Sie hier fortfahren.",
        "whatsapp.title": "Erreiche uns auf WhatsApp",
        "whatsapp.instructions":
          "<bold>Klicken</bold> oder <bold>Scannen</bold>, um WhatsApp zu öffnen",
      },
    },
    ru: {
      translation: {
        legal:
          "Отправляя сообщение, вы соглашаетесь с нашими <tosLink>условиями обслуживания</tosLink> и <ppLink>политикой конфиденциальности</ppLink>.",
        powered_by:
          "{{assistant_name}} может допускать ошибки. Работает на <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Отправить сообщение",
        "suggestions.toggle.show": "Показать предложения",
        "suggestions.toggle.hide": "Скрыть предложения",
        suggestions: "Предложения",
        assistant: "Ассистент",
        thinking: "Обдумываю",
        understanding: "Осмысление запроса",
        "handoff.success": "Передача успешна",
        "handoff.check_email": "Проверьте вашу почту",
        "handoff.anything_else": "Могу ли я помочь вам чем-то ещё?",
        "handoff.rejected": "Передача отклонена",
        "handoff.edit": "Редактировать передачу",
        "handoff.validation.firstName_required": "Требуется имя",
        "handoff.validation.lastName_required": "Требуется фамилия",
        "handoff.validation.subject_required": "Требуется описание проблемы",
        "handoff.validation.body_required": "Требуются подробности",
        "handoff.validation.body_too_short":
          "Пожалуйста, предоставьте более подробную информацию",
        "handoff.validation.email_required": "Требуется электронная почта",
        "handoff.validation.email_invalid":
          "Пожалуйста, введите действительный адрес электронной почты",
        "handoff.form.issue_label": "Проблема",
        "handoff.form.details_label": "Подробности",
        "handoff.form.firstName_label": "Имя",
        "handoff.form.lastName_label": "Фамилия",
        "handoff.form.email_label": "Ваша почта",
        "handoff.form.firstName_placeholder": "Максим",
        "handoff.form.lastName_placeholder": "Петров",
        "handoff.form.email_placeholder": "maxim@petrov.ru",
        "handoff.form.email_notice":
          "Вы получите копию, и мы свяжемся с вами в ближайшее время.",
        "handoff.error.title": "Ошибка сервера",
        "handoff.form.cancel_button": "Отмена",
        "handoff.form.send_button": "Отправить",
        "handoff.form.sending_button": "Отправка",
        "conversations.title": "Разговоры",
        "conversations.noConversationsYet": "Пока нет разговоров",
        "conversations.tapToStart":
          'Нажмите "Начать разговор", чтобы начать взаимодействие с ИИ-ассистентом',
        "conversations.startConversation": "Начать разговор",
        noConversationBranching:
          "Этот разговор уже идет в другой вкладке/окне. Пожалуйста, дождитесь завершения, прежде чем продолжить здесь.",
        "whatsapp.title": "Свяжитесь с нами в WhatsApp",
        "whatsapp.instructions":
          "<bold>Нажмите</bold> или <bold>Отсканируйте</bold>, чтобы открыть WhatsApp",
      },
    },
    fr: {
      translation: {
        legal:
          "En soumettant, vous acceptez nos <tosLink>conditions d'utilisation</tosLink> et notre <ppLink>politique de confidentialité</ppLink>.",
        powered_by:
          "{{assistant_name}} peut faire des erreurs. Propulsé par <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Envoyer un message",
        "suggestions.toggle.show": "Afficher les suggestions",
        "suggestions.toggle.hide": "Masquer les suggestions",
        suggestions: "Suggestions",
        assistant: "Assistant",
        thinking: "Réflexion",
        understanding: "Comprendre la demande",
        "handoff.success": "Transfert réussi",
        "handoff.check_email": "Vérifiez votre e-mail",
        "handoff.anything_else": "Puis-je vous aider avec autre chose ?",
        "handoff.rejected": "Transfert rejeté",
        "handoff.edit": "Modifier le transfert",
        "handoff.validation.firstName_required": "Le prénom est requis",
        "handoff.validation.lastName_required": "Le nom est requis",
        "handoff.validation.subject_required":
          "La description du problème est requise",
        "handoff.validation.body_required": "Les détails sont requis",
        "handoff.validation.body_too_short": "Veuillez fournir plus de détails",
        "handoff.validation.email_required": "L'e-mail est requis",
        "handoff.validation.email_invalid":
          "Veuillez entrer une adresse e-mail valide",
        "handoff.form.issue_label": "Problème",
        "handoff.form.details_label": "Détails",
        "handoff.form.firstName_label": "Prénom",
        "handoff.form.lastName_label": "Nom",
        "handoff.form.email_label": "Votre e-mail",
        "handoff.form.firstName_placeholder": "Jean",
        "handoff.form.lastName_placeholder": "Dupont",
        "handoff.form.email_placeholder": "jean@dupont.fr",
        "handoff.form.email_notice":
          "Vous recevrez une copie et nous vous répondrons sous peu.",
        "handoff.error.title": "Erreur backend",
        "handoff.form.cancel_button": "Annuler",
        "handoff.form.send_button": "Envoyer",
        "handoff.form.sending_button": "Envoi en cours",
        "conversations.title": "Conversations",
        "conversations.noConversationsYet": "Aucune conversation",
        "conversations.tapToStart":
          'Appuyez sur "Démarrer une conversation" pour commencer à interagir avec l\'assistant IA',
        "conversations.startConversation": "Démarrer une conversation",
        noConversationBranching:
          "Cette conversation est en cours dans un autre onglet/fenêtre. Veuillez attendre sa fin avant de continuer ici.",
        "whatsapp.title": "Contactez-nous sur WhatsApp",
        "whatsapp.instructions":
          "<bold>Cliquez</bold> ou <bold>Scannez</bold> pour ouvrir WhatsApp",
      },
    },
    it: {
      translation: {
        legal:
          "Inviando, accetti i nostri <tosLink>termini di servizio</tosLink> e la nostra <ppLink>politica sulla privacy</ppLink>.",
        powered_by:
          "{{assistant_name}} può fare errori. Offerto da <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Invia un messaggio",
        "suggestions.toggle.show": "Mostra suggerimenti",
        "suggestions.toggle.hide": "Nascondi suggerimenti",
        suggestions: "Suggerimenti",
        assistant: "Assistente",
        thinking: "Pensando",
        understanding: "Comprendere la richiesta",
        "handoff.success": "Trasferimento riuscito",
        "handoff.check_email": "Controlla la tua email",
        "handoff.anything_else": "Posso aiutarti con qualcos'altro?",
        "handoff.rejected": "Trasferimento rifiutato",
        "handoff.edit": "Modifica trasferimento",
        "handoff.validation.firstName_required": "Il nome è obbligatorio",
        "handoff.validation.lastName_required": "Il cognome è obbligatorio",
        "handoff.validation.subject_required":
          "La descrizione del problema è obbligatoria",
        "handoff.validation.body_required": "I dettagli sono obbligatori",
        "handoff.validation.body_too_short":
          "Per favore fornisci informazioni più dettagliate",
        "handoff.validation.email_required": "L'email è obbligatoria",
        "handoff.validation.email_invalid":
          "Per favore inserisci un indirizzo email valido",
        "handoff.form.issue_label": "Problema",
        "handoff.form.details_label": "Dettagli",
        "handoff.form.firstName_label": "Nome",
        "handoff.form.lastName_label": "Cognome",
        "handoff.form.email_label": "La tua email",
        "handoff.form.firstName_placeholder": "Marco",
        "handoff.form.lastName_placeholder": "Rossi",
        "handoff.form.email_placeholder": "marco@rossi.it",
        "handoff.form.email_notice":
          "Riceverai una copia e ti risponderemo a breve.",
        "handoff.error.title": "Errore del backend",
        "handoff.form.cancel_button": "Annulla",
        "handoff.form.send_button": "Invia",
        "handoff.form.sending_button": "Invio in corso",
        "conversations.title": "Conversazioni",
        "conversations.noConversationsYet": "Nessuna conversazione",
        "conversations.tapToStart":
          'Tocca "Inizia conversazione" per interagire con l\'assistente IA',
        "conversations.startConversation": "Inizia conversazione",
        noConversationBranching:
          "Questa conversazione è in corso in un'altra scheda/finestra. Attendere la sua conclusione prima di continuare qui.",
        "whatsapp.title": "Contattaci su WhatsApp",
        "whatsapp.instructions":
          "<bold>Fai clic</bold> o <bold>Scansiona</bold> per aprire WhatsApp",
      },
    },
    es: {
      translation: {
        legal:
          "Al enviar, aceptas nuestros <tosLink>términos de servicio</tosLink> y <ppLink>política de privacidad</ppLink>.",
        powered_by:
          "{{assistant_name}} puede cometer errores. Desarrollado por <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Enviar un mensaje",
        "suggestions.toggle.show": "Mostrar sugerencias",
        "suggestions.toggle.hide": "Ocultar sugerencias",
        suggestions: "Sugerencias",
        assistant: "Asistente",
        thinking: "Pensando",
        understanding: "Entendiendo la consulta",
        "handoff.success": "Transferencia exitosa",
        "handoff.check_email": "Revise su correo electrónico",
        "handoff.anything_else": "¿Hay algo más en lo que pueda ayudarle?",
        "handoff.rejected": "Transferencia rechazada",
        "handoff.edit": "Editar transferencia",
        "handoff.validation.firstName_required": "El nombre es obligatorio",
        "handoff.validation.lastName_required": "El apellido es obligatorio",
        "handoff.validation.subject_required":
          "La descripción del problema es obligatoria",
        "handoff.validation.body_required": "Los detalles son obligatorios",
        "handoff.validation.body_too_short":
          "Por favor, proporcione información más detallada",
        "handoff.validation.email_required":
          "El correo electrónico es obligatorio",
        "handoff.validation.email_invalid":
          "Por favor, introduzca una dirección de correo válida",
        "handoff.form.issue_label": "Problema",
        "handoff.form.details_label": "Detalles",
        "handoff.form.firstName_label": "Nombre",
        "handoff.form.lastName_label": "Apellido",
        "handoff.form.email_label": "Su correo",
        "handoff.form.firstName_placeholder": "Juan",
        "handoff.form.lastName_placeholder": "García",
        "handoff.form.email_placeholder": "juan@garcia.es",
        "handoff.form.email_notice":
          "Recibirá una copia y le responderemos en breve.",
        "handoff.error.title": "Error del servidor",
        "handoff.form.cancel_button": "Cancelar",
        "handoff.form.send_button": "Enviar",
        "handoff.form.sending_button": "Enviando",
        "conversations.title": "Conversaciones",
        "conversations.noConversationsYet": "Aún no hay conversaciones",
        "conversations.tapToStart":
          'Toca "Iniciar conversación" para empezar a interactuar con el asistente de IA',
        "conversations.startConversation": "Iniciar conversación",
        noConversationBranching:
          "Esta conversación está en curso en otra pestaña/ventana. Espere a que se complete antes de continuar aquí.",
        "whatsapp.title": "Contáctanos por WhatsApp",
        "whatsapp.instructions":
          "<bold>Haz clic</bold> o <bold>Escanea</bold> para abrir WhatsApp",
      },
    },
    pl: {
      translation: {
        legal:
          "Wysyłając wiadomość, zgadzasz się na nasze <tosLink>warunki świadczenia usług</tosLink> oraz <ppLink>politykę prywatności</ppLink>.",
        powered_by:
          "{{assistant_name}} może popełniać błędy. Obsługiwane przez <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Wyślij wiadomość",
        "suggestions.toggle.show": "Pokaż sugestie",
        "suggestions.toggle.hide": "Ukryj sugestie",
        suggestions: "Sugestie",
        assistant: "Asystent",
        thinking: "Myślenie",
        understanding: "Zrozumienie zapytania",

        "handoff.success": "Przekazanie udane",
        "handoff.check_email": "Sprawdź swoją pocztę",
        "handoff.anything_else": "Czy mogę w czymś jeszcze pomóc?",
        "handoff.rejected": "Przekazanie odrzucone",
        "handoff.edit": "Edytuj przekazanie",
        "handoff.validation.firstName_required": "Imię jest wymagane",
        "handoff.validation.lastName_required": "Nazwisko jest wymagane",
        "handoff.validation.subject_required": "Opis problemu jest wymagany",
        "handoff.validation.body_required": "Szczegóły są wymagane",
        "handoff.validation.body_too_short":
          "Proszę podać więcej szczegółowych informacji",
        "handoff.validation.email_required": "Email jest wymagany",
        "handoff.validation.email_invalid":
          "Proszę podać prawidłowy adres email",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Szczegóły",
        "handoff.form.firstName_label": "Imię",
        "handoff.form.lastName_label": "Nazwisko",
        "handoff.form.email_label": "Twój email",
        "handoff.form.firstName_placeholder": "Jan",
        "handoff.form.lastName_placeholder": "Kowalski",
        "handoff.form.email_placeholder": "jan@kowalski.pl",
        "handoff.form.email_notice":
          "Otrzymasz kopię i skontaktujemy się wkrótce.",
        "handoff.error.title": "Błąd serwera",
        "handoff.form.cancel_button": "Anuluj",
        "handoff.form.send_button": "Wyślij",
        "handoff.form.sending_button": "Wysyłanie",
        "conversations.title": "Rozmowy",
        "conversations.noConversationsYet": "Brak rozmów",
        "conversations.tapToStart":
          'Naciśnij "Rozpocznij rozmowę", aby zacząć interakcję z asystentem AI',
        "conversations.startConversation": "Rozpocznij rozmowę",
        noConversationBranching:
          "Ta rozmowa jest w toku w innym oknie/karcie. Proszę poczekać na jej zakończenie przed kontynuowaniem tutaj.",
        "whatsapp.title": "Skontaktuj się z nami na WhatsApp",
        "whatsapp.instructions":
          "<bold>Kliknij</bold> lub <bold>Zeskanuj</bold>, aby otworzyć WhatsApp",
      },
    },
    uk: {
      translation: {
        legal:
          "Надсилаючи повідомлення, ви погоджуєтеся з нашими <tosLink>умовами обслуговування</tosLink> і <ppLink>політикою конфіденційності</ppLink>.",
        powered_by:
          "{{assistant_name}} може допускати помилки. Підтримується <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Відправити повідомлення",
        "suggestions.toggle.show": "Показати пропозиції",
        "suggestions.toggle.hide": "Сховати пропозиції",
        suggestions: "Пропозиції",
        assistant: "Асистент",
        thinking: "Думаю",
        understanding: "Розуміння запиту",
        "handoff.success": "Передачу виконано успішно",
        "handoff.check_email": "Перевірте вашу пошту",
        "handoff.anything_else": "Чи можу я ще чимось допомогти?",
        "handoff.rejected": "Передачу відхилено",
        "handoff.edit": "Редагувати передачу",
        "handoff.validation.firstName_required": "Ім'я обов'язкове",
        "handoff.validation.lastName_required": "Прізвище обов'язкове",
        "handoff.validation.subject_required": "Опис проблеми обов'язковий",
        "handoff.validation.body_required": "Деталі обов'язкові",
        "handoff.validation.body_too_short":
          "Будь ласка, надайте більш детальну інформацію",
        "handoff.validation.email_required": "Email обов'язковий",
        "handoff.validation.email_invalid":
          "Будь ласка, введіть дійсну email адресу",
        "handoff.form.issue_label": "Проблема",
        "handoff.form.details_label": "Деталі",
        "handoff.form.firstName_label": "Ім'я",
        "handoff.form.lastName_label": "Прізвище",
        "handoff.form.email_label": "Ваша пошта",
        "handoff.form.firstName_placeholder": "Іван",
        "handoff.form.lastName_placeholder": "Петренко",
        "handoff.form.email_placeholder": "ivan@petrenko.ua",
        "handoff.form.email_notice":
          "Ви отримаєте копію і ми незабаром зв'яжемося з вами.",
        "handoff.error.title": "Помилка сервера",
        "handoff.form.cancel_button": "Скасувати",
        "handoff.form.send_button": "Надіслати",
        "handoff.form.sending_button": "Надсилання",
        "conversations.title": "Розмови",
        "conversations.noConversationsYet": "Ще немає розмов",
        "conversations.tapToStart":
          'Натисніть "Почати розмову", щоб почати взаємодію з ШІ-асистентом',
        "conversations.startConversation": "Почати розмову",
        noConversationBranching:
          "Ця розмова вже триває в іншій вкладці/вікні. Будь ласка, зачекайте на завершення, перш ніж продовжити тут.",
        "whatsapp.title": "Зв'яжіться з нами в WhatsApp",
        "whatsapp.instructions":
          "<bold>Натисніть</bold> або <bold>Скануйте</bold>, щоб відкрити WhatsApp",
      },
    },
    ro: {
      translation: {
        legal:
          "Prin trimiterea mesajului, sunteți de acord cu <tosLink>termenii serviciului</tosLink> și <ppLink>politica de confidențialitate</ppLink>.",
        powered_by:
          "{{assistant_name}} poate face greșeli. Alimentat de <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Trimite un mesaj",
        "suggestions.toggle.show": "Afișați sugestii",
        "suggestions.toggle.hide": "Ascundeți sugestii",
        suggestions: "Sugestii",
        assistant: "Asistent",
        thinking: "Gândire",
        understanding: "Înțelegerea întrebării",
        "handoff.success": "Transfer reușit",
        "handoff.check_email": "Verificați-vă emailul",
        "handoff.anything_else": "Vă mai pot ajuta cu ceva?",
        "handoff.rejected": "Transfer respins",
        "handoff.edit": "Editare transfer",
        "handoff.validation.firstName_required": "Prenumele este obligatoriu",
        "handoff.validation.lastName_required": "Numele este obligatoriu",
        "handoff.validation.subject_required":
          "Descrierea problemei este obligatorie",
        "handoff.validation.body_required": "Detaliile sunt obligatorii",
        "handoff.validation.body_too_short":
          "Vă rugăm să furnizați informații mai detaliate",
        "handoff.validation.email_required": "Emailul este obligatoriu",
        "handoff.validation.email_invalid":
          "Vă rugăm să introduceți o adresă de email validă",
        "handoff.form.issue_label": "Problemă",
        "handoff.form.details_label": "Detalii",
        "handoff.form.firstName_label": "Prenume",
        "handoff.form.lastName_label": "Nume",
        "handoff.form.email_label": "Emailul dvs.",
        "handoff.form.firstName_placeholder": "Ion",
        "handoff.form.lastName_placeholder": "Popescu",
        "handoff.form.email_placeholder": "ion@popescu.ro",
        "handoff.form.email_notice":
          "Veți primi o copie și vă vom contacta în curând.",
        "handoff.error.title": "Eroare backend",
        "handoff.form.cancel_button": "Anulare",
        "handoff.form.send_button": "Trimite",
        "handoff.form.sending_button": "Se trimite",
        "conversations.title": "Conversații",
        "conversations.noConversationsYet": "Nicio conversație încă",
        "conversations.tapToStart":
          'Apasă "Începe conversația" pentru a interacționa cu asistentul AI',
        "conversations.startConversation": "Începe conversația",
        noConversationBranching:
          "Această conversație este în curs într-o altă filă/fereastră. Vă rugăm să așteptați finalizarea înainte de a continua aici.",
        "whatsapp.title": "Contactați-ne pe WhatsApp",
        "whatsapp.instructions":
          "<bold>Faceți clic</bold> sau <bold>Scanați</bold> pentru a deschide WhatsApp",
      },
    },
    nl: {
      translation: {
        legal:
          "Door te verzenden, ga je akkoord met onze <tosLink>servicevoorwaarden</tosLink> en <ppLink>privacybeleid</ppLink>.",
        powered_by:
          "{{assistant_name}} kan fouten maken. Aangedreven door <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Stuur een bericht",
        "suggestions.toggle.show": "Toon suggesties",
        "suggestions.toggle.hide": "Verberg suggesties",
        suggestions: "Suggesties",
        assistant: "Assistent",
        thinking: "Denken",
        understanding: "Vraag begrijpen",
        "handoff.success": "Overdracht succesvol",
        "handoff.check_email": "Controleer uw e-mail",
        "handoff.anything_else": "Kan ik u nog ergens anders mee helpen?",
        "handoff.rejected": "Overdracht geweigerd",
        "handoff.edit": "Overdracht bewerken",
        "handoff.validation.firstName_required": "Voornaam is verplicht",
        "handoff.validation.lastName_required": "Achternaam is verplicht",
        "handoff.validation.subject_required":
          "Probleembeschrijving is verplicht",
        "handoff.validation.body_required": "Details zijn verplicht",
        "handoff.validation.body_too_short":
          "Geef meer gedetailleerde informatie",
        "handoff.validation.email_required": "E-mail is verplicht",
        "handoff.validation.email_invalid": "Voer een geldig e-mailadres in",
        "handoff.form.issue_label": "Probleem",
        "handoff.form.details_label": "Details",
        "handoff.form.firstName_label": "Voornaam",
        "handoff.form.lastName_label": "Achternaam",
        "handoff.form.email_label": "Uw e-mail",
        "handoff.form.firstName_placeholder": "Jan",
        "handoff.form.lastName_placeholder": "de Vries",
        "handoff.form.email_placeholder": "jan@devries.nl",
        "handoff.form.email_notice":
          "U ontvangt een kopie en we nemen spoedig contact met u op.",
        "handoff.error.title": "Backend fout",
        "handoff.form.cancel_button": "Annuleren",
        "handoff.form.send_button": "Verzenden",
        "handoff.form.sending_button": "Verzenden...",
        "conversations.title": "Gesprekken",
        "conversations.noConversationsYet": "Nog geen gesprekken",
        "conversations.tapToStart":
          'Tik op "Start gesprek" om te beginnen met de AI-assistent',
        "conversations.startConversation": "Start gesprek",
        noConversationBranching:
          "Dit gesprek is al gaande in een ander tabblad/venster. Wacht tot het is voltooid voordat u hier verdergaat.",
        "whatsapp.title": "Neem contact met ons op via WhatsApp",
        "whatsapp.instructions":
          "<bold>Klik</bold> of <bold>Scan</bold> om WhatsApp te openen",
      },
    },
    hr: {
      translation: {
        legal:
          "Slanjem pristajete na naše <tosLink>uvjete usluge</tosLink> i <ppLink>pravila privatnosti</ppLink>.",
        powered_by:
          "{{assistant_name}} može pogriješiti. Pokreće <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Pošalji poruku",
        "suggestions.toggle.show": "Prikaži prijedloge",
        "suggestions.toggle.hide": "Sakrij prijedloge",
        suggestions: "Prijedlozi",
        assistant: "Asistent",
        thinking: "Razmišljanje",
        understanding: "Razumijevanje upita",
        "handoff.success": "Prijenos uspješan",
        "handoff.check_email": "Provjerite svoju e-poštu",
        "handoff.anything_else": "Mogu li vam još kako pomoći?",
        "handoff.rejected": "Prijenos odbijen",
        "handoff.edit": "Uredi prijenos",
        "handoff.validation.firstName_required": "Ime je obavezno",
        "handoff.validation.lastName_required": "Prezime je obavezno",
        "handoff.validation.subject_required": "Opis problema je obavezan",
        "handoff.validation.body_required": "Detalji su obavezni",
        "handoff.validation.body_too_short": "Molimo navedite više detalja",
        "handoff.validation.email_required": "E-mail je obavezan",
        "handoff.validation.email_invalid": "Unesite valjanu e-mail adresu",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detalji",
        "handoff.form.firstName_label": "Ime",
        "handoff.form.lastName_label": "Prezime",
        "handoff.form.email_label": "Vaš e-mail",
        "handoff.form.firstName_placeholder": "Ivan",
        "handoff.form.lastName_placeholder": "Horvat",
        "handoff.form.email_placeholder": "ivan@horvat.hr",
        "handoff.form.email_notice":
          "Primit ćete kopiju i uskoro ćemo vas kontaktirati.",
        "handoff.error.title": "Greška poslužitelja",
        "handoff.form.cancel_button": "Odustani",
        "handoff.form.send_button": "Pošalji",
        "handoff.form.sending_button": "Slanje",
        "conversations.title": "Razgovori",
        "conversations.noConversationsYet": "Još nema razgovora",
        "conversations.tapToStart":
          'Dodirnite "Započni razgovor" za interakciju s AI asistentom',
        "conversations.startConversation": "Započni razgovor",
        noConversationBranching:
          "Ovaj razgovor već se odvija u drugoj kartici/prozoru. Pričekajte da se završi prije nego što nastavite ovdje.",
        "whatsapp.title": "Kontaktirajte nas putem WhatsApp-a",
        "whatsapp.instructions":
          "<bold>Kliknite</bold> ili <bold>Skenirajte</bold> za otvaranje WhatsApp-a",
      },
    },
    tr: {
      translation: {
        legal:
          "Göndererek <tosLink>hizmet şartlarımızı</tosLink> ve <ppLink>gizlilik politikamızı</ppLink> kabul etmiş olursunuz.",
        powered_by:
          "{{assistant_name}} hata yapabilir. <botBrainsLink>botBrains</botBrainsLink> tarafından desteklenmektedir.",
        "prompt.placeholder": "Bir mesaj gönder",
        "suggestions.toggle.show": "Önerileri göster",
        "suggestions.toggle.hide": "Önerileri gizle",
        suggestions: "Öneriler",
        assistant: "Asistan",
        thinking: "Düşünüyor",
        understanding: "Soruyu anlama",
        "handoff.success": "Aktarım başarılı",
        "handoff.check_email": "E-postanızı kontrol edin",
        "handoff.anything_else": "Başka bir konuda yardımcı olabilir miyim?",
        "handoff.rejected": "Aktarım reddedildi",
        "handoff.edit": "Aktarımı düzenle",
        "handoff.validation.firstName_required": "Ad gereklidir",
        "handoff.validation.lastName_required": "Soyad gereklidir",
        "handoff.validation.subject_required": "Sorun açıklaması gereklidir",
        "handoff.validation.body_required": "Detaylar gereklidir",
        "handoff.validation.body_too_short": "Lütfen daha detaylı bilgi verin",
        "handoff.validation.email_required": "E-posta gereklidir",
        "handoff.validation.email_invalid":
          "Lütfen geçerli bir e-posta adresi girin",
        "handoff.form.issue_label": "Sorun",
        "handoff.form.details_label": "Detaylar",
        "handoff.form.firstName_label": "Ad",
        "handoff.form.lastName_label": "Soyad",
        "handoff.form.email_label": "E-postanız",
        "handoff.form.firstName_placeholder": "Mehmet",
        "handoff.form.lastName_placeholder": "Yılmaz",
        "handoff.form.email_placeholder": "mehmet@yilmaz.tr",
        "handoff.form.email_notice":
          "Bir kopya alacaksınız ve yakında size geri döneceğiz.",
        "handoff.error.title": "Sunucu hatası",
        "handoff.form.cancel_button": "İptal",
        "handoff.form.send_button": "Gönder",
        "handoff.form.sending_button": "Gönderiliyor",
        "conversations.title": "Konuşmalar",
        "conversations.noConversationsYet": "Henüz konuşma yok",
        "conversations.tapToStart":
          'AI asistanı ile etkileşime başlamak için "Konuşma Başlat"a dokunun',
        "conversations.startConversation": "Konuşma Başlat",
        noConversationBranching:
          "Bu konuşma başka bir sekmede/pencerede devam ediyor. Lütfen burada devam etmeden önce tamamlanmasını bekleyin.",
        "whatsapp.title": "WhatsApp üzerinden bizimle iletişime geçin",
        "whatsapp.instructions":
          "<bold>Tıklayın</bold> veya <bold>Taramak</bold> için WhatsApp'ı açın",
      },
    },
    el: {
      translation: {
        legal:
          "Υποβάλλοντας, αποδέχεστε τους <tosLink>όρους υπηρεσίας</tosLink> και την <ppLink>πολιτική απορρήτου</ppLink> μας.",
        powered_by:
          "{{assistant_name}} μπορεί να κάνει λάθη. Υποστηρίζεται από <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Στείλτε ένα μήνυμα",
        "suggestions.toggle.show": "Εμφάνιση προτάσεων",
        "suggestions.toggle.hide": "Απόκρυψη προτάσεων",
        suggestions: "Προτάσεις",
        assistant: "Βοηθός",
        thinking: "Σκέψη",
        understanding: "Κατανόηση ερώτησης",
        "handoff.success": "Επιτυχής μεταφορά",
        "handoff.check_email": "Ελέγξτε το email σας",
        "handoff.anything_else": "Μπορώ να σας βοηθήσω με κάτι άλλο;",
        "handoff.rejected": "Η μεταφορά απορρίφθηκε",
        "handoff.edit": "Επεξεργασία μεταφοράς",
        "handoff.validation.firstName_required": "Το όνομα είναι υποχρεωτικό",
        "handoff.validation.lastName_required": "Το επώνυμο είναι υποχρεωτικό",
        "handoff.validation.subject_required":
          "Η περιγραφή του προβλήματος είναι υποχρεωτική",
        "handoff.validation.body_required":
          "Οι λεπτομέρειες είναι υποχρεωτικές",
        "handoff.validation.body_too_short":
          "Παρακαλώ δώστε περισσότερες λεπτομέρειες",
        "handoff.validation.email_required": "Το email είναι υποχρεωτικό",
        "handoff.validation.email_invalid":
          "Παρακαλώ εισάγετε έγκυρη διεύθυνση email",
        "handoff.form.issue_label": "Πρόβλημα",
        "handoff.form.details_label": "Λεπτομέρειες",
        "handoff.form.firstName_label": "Όνομα",
        "handoff.form.lastName_label": "Επώνυμο",
        "handoff.form.email_label": "Το email σας",
        "handoff.form.firstName_placeholder": "Γιώργος",
        "handoff.form.lastName_placeholder": "Παπαδόπουλος",
        "handoff.form.email_placeholder": "giorgos@papadopoulos.gr",
        "handoff.form.email_notice":
          "Θα λάβετε ένα αντίγραφο και θα επικοινωνήσουμε σύντομα μαζί σας.",
        "handoff.error.title": "Σφάλμα διακομιστή",
        "handoff.form.cancel_button": "Ακύρωση",
        "handoff.form.send_button": "Αποστολή",
        "handoff.form.sending_button": "Αποστολή...",
        "conversations.title": "Συνομιλίες",
        "conversations.noConversationsYet": "Δεν υπάρχουν συνομιλίες ακόμα",
        "conversations.tapToStart":
          'Πατήστε "Έναρξη συνομιλίας" για να ξεκινήσετε την αλληλεπίδραση με τον AI βοηθό',
        "conversations.startConversation": "Έναρξη συνομιλίας",
        noConversationBranching:
          "Αυτή η συνομιλία είναι σε εξέλιξη σε άλλη καρτέλα/παράθυρο. Περιμένετε να ολοκληρωθεί πριν συνεχίσετε εδώ.",
        "whatsapp.title": "Επικοινωνήστε μαζί μας στο WhatsApp",
        "whatsapp.instructions":
          "<bold>Κάντε κλικ</bold> ή <bold>Σαρώστε</bold> για να ανοίξετε το WhatsApp",
      },
    },
    hu: {
      translation: {
        legal:
          "Az üzenet elküldésével elfogadja az <tosLink>felhasználási feltételeinket</tosLink> és az <ppLink>adatvédelmi irányelveinket</ppLink>.",
        powered_by:
          "{{assistant_name}} hibázhat. Az <botBrainsLink>botBrains</botBrainsLink> támogatásával.",
        "prompt.placeholder": "Üzenet küldése",
        "suggestions.toggle.show": "Javaslatok megjelenítése",
        "suggestions.toggle.hide": "Javaslatok elrejtése",
        suggestions: "Javaslatok",
        assistant: "Asszisztens",
        thinking: "Gondolkodás",
        understanding: "Kérés megértése",
        "handoff.success": "Sikeres átadás",
        "handoff.check_email": "Ellenőrizze az e-mailjét",
        "handoff.anything_else": "Segíthetek még valamiben?",
        "handoff.rejected": "Átadás elutasítva",
        "handoff.edit": "Átadás szerkesztése",
        "handoff.validation.firstName_required": "A keresztnév kötelező",
        "handoff.validation.lastName_required": "A vezetéknév kötelező",
        "handoff.validation.subject_required": "A probléma leírása kötelező",
        "handoff.validation.body_required": "A részletek kötelezőek",
        "handoff.validation.body_too_short":
          "Kérjük, adjon meg részletesebb információt",
        "handoff.validation.email_required": "Az e-mail kötelező",
        "handoff.validation.email_invalid":
          "Kérjük, adjon meg érvényes e-mail címet",
        "handoff.form.issue_label": "Probléma",
        "handoff.form.details_label": "Részletek",
        "handoff.form.firstName_label": "Keresztnév",
        "handoff.form.lastName_label": "Vezetéknév",
        "handoff.form.email_label": "Az Ön e-mailje",
        "handoff.form.firstName_placeholder": "János",
        "handoff.form.lastName_placeholder": "Kovács",
        "handoff.form.email_placeholder": "kovacs.janos@email.hu",
        "handoff.form.email_notice":
          "Másolatot kap és hamarosan felvesszük Önnel a kapcsolatot.",
        "handoff.error.title": "Szerverhiba",
        "handoff.form.cancel_button": "Mégse",
        "handoff.form.send_button": "Küldés",
        "handoff.form.sending_button": "Küldés...",
        "conversations.title": "Beszélgetések",
        "conversations.noConversationsYet": "Még nincsenek beszélgetések",
        "conversations.tapToStart":
          'Érintse meg a "Beszélgetés indítása" gombot az AI asszisztenssel való interakcióhoz',
        "conversations.startConversation": "Beszélgetés indítása",
        noConversationBranching:
          "Ez a beszélgetés egy másik lap/fülön zajlik. Kérjük, várja meg a befejezését, mielőtt itt folytatná.",
        "whatsapp.title": "Lépjen kapcsolatba velünk a WhatsApp-on",
        "whatsapp.instructions":
          "<bold>Kattintson</bold> vagy <bold>Szkenneljen</bold> a WhatsApp megnyitásához",
      },
    },
    sv: {
      translation: {
        legal:
          "Genom att skicka godkänner du våra <tosLink>användarvillkor</tosLink> och <ppLink>integritetspolicy</ppLink>.",
        powered_by:
          "{{assistant_name}} kan göra misstag. Drivs av <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Skicka ett meddelande",
        "suggestions.toggle.show": "Visa förslag",
        "suggestions.toggle.hide": "Dölj förslag",
        suggestions: "Förslag",
        assistant: "Assistent",
        thinking: "Tänker",
        understanding: "Förstår frågan",
        "handoff.success": "Överföring lyckades",
        "handoff.check_email": "Kontrollera din e-post",
        "handoff.anything_else": "Kan jag hjälpa dig med något annat?",
        "handoff.rejected": "Överföring avvisad",
        "handoff.edit": "Redigera överföring",
        "handoff.validation.firstName_required": "Förnamn krävs",
        "handoff.validation.lastName_required": "Efternamn krävs",
        "handoff.validation.subject_required": "Problembeskrivning krävs",
        "handoff.validation.body_required": "Detaljer krävs",
        "handoff.validation.body_too_short":
          "Vänligen ge mer detaljerad information",
        "handoff.validation.email_required": "E-post krävs",
        "handoff.validation.email_invalid": "Ange en giltig e-postadress",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detaljer",
        "handoff.form.firstName_label": "Förnamn",
        "handoff.form.lastName_label": "Efternamn",
        "handoff.form.email_label": "Din e-post",
        "handoff.form.firstName_placeholder": "Erik",
        "handoff.form.lastName_placeholder": "Andersson",
        "handoff.form.email_placeholder": "erik@andersson.se",
        "handoff.form.email_notice": "Du får en kopia och vi återkommer snart.",
        "handoff.error.title": "Serverfel",
        "handoff.form.cancel_button": "Avbryt",
        "handoff.form.send_button": "Skicka",
        "handoff.form.sending_button": "Skickar",
        "conversations.title": "Konversationer",
        "conversations.noConversationsYet": "Inga konversationer än",
        "conversations.tapToStart":
          'Tryck på "Starta konversation" för att börja interagera med AI-assistenten',
        "conversations.startConversation": "Starta konversation",
        noConversationBranching:
          "Denna konversation pågår redan i en annan flik/fönster. Vänta på att den avslutas innan du fortsätter här.",
        "whatsapp.title": "Kontakta oss på WhatsApp",
        "whatsapp.instructions":
          "<bold>Klicka</bold> eller <bold>Skanna</bold> för att öppna WhatsApp",
      },
    },
    cs: {
      translation: {
        legal:
          "Odesláním souhlasíte s našimi <tosLink>podmínkami služby</tosLink> a <ppLink>zásadami ochrany osobních údajů</ppLink>.",
        powered_by:
          "{{assistant_name}} může udělat chyby. Pohání <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Odeslat zprávu",
        "suggestions.toggle.show": "Zobrazit návrhy",
        "suggestions.toggle.hide": "Skrýt návrhy",
        suggestions: "Návrhy",
        assistant: "Asistent",
        thinking: "Přemýšlení",
        understanding: "Porozumění dotazu",
        "handoff.success": "Předání úspěšné",
        "handoff.check_email": "Zkontrolujte svůj email",
        "handoff.anything_else": "Mohu vám ještě s něčím pomoci?",
        "handoff.rejected": "Předání zamítnuto",
        "handoff.edit": "Upravit předání",
        "handoff.validation.firstName_required": "Jméno je povinné",
        "handoff.validation.lastName_required": "Příjmení je povinné",
        "handoff.validation.subject_required": "Popis problému je povinný",
        "handoff.validation.body_required": "Podrobnosti jsou povinné",
        "handoff.validation.body_too_short":
          "Prosím, poskytněte podrobnější informace",
        "handoff.validation.email_required": "Email je povinný",
        "handoff.validation.email_invalid":
          "Prosím, zadejte platnou emailovou adresu",
        "handoff.form.issue_label": "Problém",
        "handoff.form.details_label": "Podrobnosti",
        "handoff.form.firstName_label": "Jméno",
        "handoff.form.lastName_label": "Příjmení",
        "handoff.form.email_label": "Váš email",
        "handoff.form.firstName_placeholder": "Jan",
        "handoff.form.lastName_placeholder": "Novotný",
        "handoff.form.email_placeholder": "jan@novotny.cz",
        "handoff.form.email_notice": "Obdržíte kopii a brzy se vám ozveme.",
        "handoff.error.title": "Chyba serveru",
        "handoff.form.cancel_button": "Zrušit",
        "handoff.form.send_button": "Odeslat",
        "handoff.form.sending_button": "Odesílání",
        "conversations.title": "Konverzace",
        "conversations.noConversationsYet": "Zatím žádné konverzace",
        "conversations.tapToStart":
          'Klepněte na "Zahájit konverzaci" pro interakci s AI asistentem',
        "conversations.startConversation": "Zahájit konverzaci",
        noConversationBranching:
          "Tato konverzace již probíhá v jiné kartě/okně. Před pokračováním zde prosím počkejte na její dokončení.",
        "whatsapp.title": "Kontaktujte nás na WhatsAppu",
        "whatsapp.instructions":
          "<bold>Klikněte</bold> nebo <bold>Načtěte</bold> pro otevření WhatsAppu",
      },
    },
    pt: {
      translation: {
        legal:
          "Ao enviar, você concorda com nossos <tosLink>termos de serviço</tosLink> e <ppLink>política de privacidade</ppLink>.",
        powered_by:
          "{{assistant_name}} pode cometer erros. Impulsionado por <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Enviar uma mensagem",
        "suggestions.toggle.show": "Mostrar sugestões",
        "suggestions.toggle.hide": "Ocultar sugestões",
        suggestions: "Sugestões",
        assistant: "Assistente",
        thinking: "Pensando",
        understanding: "Entendendo a pergunta",
        "handoff.success": "Transferência bem-sucedida",
        "handoff.check_email": "Verifique seu email",
        "handoff.anything_else": "Posso ajudar com mais alguma coisa?",
        "handoff.rejected": "Transferência rejeitada",
        "handoff.edit": "Editar transferência",
        "handoff.validation.firstName_required": "Nome é obrigatório",
        "handoff.validation.lastName_required": "Sobrenome é obrigatório",
        "handoff.validation.subject_required":
          "Descrição do problema é obrigatória",
        "handoff.validation.body_required": "Detalhes são obrigatórios",
        "handoff.validation.body_too_short":
          "Por favor, forneça informações mais detalhadas",
        "handoff.validation.email_required": "Email é obrigatório",
        "handoff.validation.email_invalid":
          "Por favor, insira um endereço de email válido",
        "handoff.form.issue_label": "Problema",
        "handoff.form.details_label": "Detalhes",
        "handoff.form.firstName_label": "Nome",
        "handoff.form.lastName_label": "Sobrenome",
        "handoff.form.email_label": "Seu email",
        "handoff.form.firstName_placeholder": "João",
        "handoff.form.lastName_placeholder": "Silva",
        "handoff.form.email_placeholder": "joao@silva.com.br",
        "handoff.form.email_notice":
          "Você receberá uma cópia e entraremos em contato em breve.",
        "handoff.error.title": "Erro do servidor",
        "handoff.form.cancel_button": "Cancelar",
        "handoff.form.send_button": "Enviar",
        "handoff.form.sending_button": "Enviando",
        "conversations.title": "Conversas",
        "conversations.noConversationsYet": "Ainda não há conversas",
        "conversations.tapToStart":
          'Toque em "Iniciar conversa" para começar a interagir com o assistente de IA',
        "conversations.startConversation": "Iniciar conversa",
        noConversationBranching:
          "Esta conversa já está em andamento em outra aba/janela. Aguarde a conclusão antes de continuar aqui.",
        "whatsapp.title": "Entre em contato conosco pelo WhatsApp",
        "whatsapp.instructions":
          "<bold>Toque</bold> ou <bold>Escaneie</bold> para abrir o WhatsApp",
      },
    },
    ca: {
      translation: {
        legal:
          "En enviar, acceptes els nostres <tosLink>termes del servei</tosLink> i la nostra <ppLink>política de privacitat</ppLink>.",
        powered_by:
          "{{assistant_name}} pot cometre errors. Potenciat per <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Enviar un missatge",
        "suggestions.toggle.show": "Mostra suggeriments",
        "suggestions.toggle.hide": "Amaga suggeriments",
        suggestions: "Suggeriments",
        assistant: "Assistent",
        thinking: "Pensant",
        understanding: "Entenent la consulta",
        "handoff.success": "Transferència exitosa",
        "handoff.check_email": "Comprovi el seu correu electrònic",
        "handoff.anything_else":
          "Hi ha alguna altra cosa en què pugui ajudar-lo?",
        "handoff.rejected": "Transferència rebutjada",
        "handoff.edit": "Editar transferència",
        "handoff.validation.firstName_required": "El nom és obligatori",
        "handoff.validation.lastName_required": "El cognom és obligatori",
        "handoff.validation.subject_required":
          "La descripció del problema és obligatòria",
        "handoff.validation.body_required": "Els detalls són obligatoris",
        "handoff.validation.body_too_short":
          "Si us plau, proporcioneu informació més detallada",
        "handoff.validation.email_required":
          "El correu electrònic és obligatori",
        "handoff.validation.email_invalid":
          "Si us plau, introduïu una adreça de correu vàlida",
        "handoff.form.issue_label": "Problema",
        "handoff.form.details_label": "Detalls",
        "handoff.form.firstName_label": "Nom",
        "handoff.form.lastName_label": "Cognom",
        "handoff.form.email_label": "El vostre correu",
        "handoff.form.firstName_placeholder": "Joan",
        "handoff.form.lastName_placeholder": "Puig",
        "handoff.form.email_placeholder": "joan@puig.cat",
        "handoff.form.email_notice": "Rebreu una còpia i us respondrem aviat.",
        "handoff.error.title": "Error del servidor",
        "handoff.form.cancel_button": "Cancel·lar",
        "handoff.form.send_button": "Enviar",
        "handoff.form.sending_button": "Enviant",
        "conversations.title": "Converses",
        "conversations.noConversationsYet": "Encara no hi ha converses",
        "conversations.tapToStart":
          "Toca \"Iniciar conversa\" per començar a interactuar amb l'assistent d'IA",
        "conversations.startConversation": "Iniciar conversa",
        noConversationBranching:
          "Aquesta conversa ja està en curs en una altra pestanya/finestra. Espereu que finalitzi abans de continuar aquí.",
        "whatsapp.title": "Contacta'ns per WhatsApp",
        "whatsapp.instructions":
          "<bold>Feu clic</bold> o <bold>Escanegeu</bold> per obrir WhatsApp",
      },
    },
    sr: {
      translation: {
        legal:
          "Slanjem prihvatate naše <tosLink>uslove korišćenja</tosLink> i <ppLink>politiku privatnosti</ppLink>.",
        powered_by:
          "{{assistant_name}} može praviti greške. Pokreće <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Pošaljite poruku",
        "suggestions.toggle.show": "Prikaži predloge",
        "suggestions.toggle.hide": "Sakrij predloge",
        suggestions: "Predlozi",
        assistant: "Asistent",
        thinking: "Razmišljanje",
        understanding: "Razumevanje upita",
        "handoff.success": "Prenos uspešan",
        "handoff.check_email": "Proverite vašu e-poštu",
        "handoff.anything_else": "Mogu li još nečim da vam pomognem?",
        "handoff.rejected": "Prenos odbijen",
        "handoff.edit": "Izmeni prenos",
        "handoff.validation.firstName_required": "Ime je obavezno",
        "handoff.validation.lastName_required": "Prezime je obavezno",
        "handoff.validation.subject_required": "Opis problema je obavezan",
        "handoff.validation.body_required": "Detalji su obavezni",
        "handoff.validation.body_too_short":
          "Molimo unesite detaljnije informacije",
        "handoff.validation.email_required": "E-pošta je obavezna",
        "handoff.validation.email_invalid": "Unesite važeću e-mail adresu",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detalji",
        "handoff.form.firstName_label": "Ime",
        "handoff.form.lastName_label": "Prezime",
        "handoff.form.email_label": "Vaša e-pošta",
        "handoff.form.firstName_placeholder": "Marko",
        "handoff.form.lastName_placeholder": "Petrović",
        "handoff.form.email_placeholder": "marko@petrovic.rs",
        "handoff.form.email_notice":
          "Primićete kopiju i uskoro ćemo vas kontaktirati.",
        "handoff.error.title": "Greška servera",
        "handoff.form.cancel_button": "Otkaži",
        "handoff.form.send_button": "Pošalji",
        "handoff.form.sending_button": "Slanje",
        "conversations.title": "Разговори",
        "conversations.noConversationsYet": "Још нема разговора",
        "conversations.tapToStart":
          'Додирните "Започни разговор" да бисте почели интеракцију са АИ асистентом',
        "conversations.startConversation": "Започни разговор",
        noConversationBranching:
          "Ovaj razgovor već se odvija u drugoj kartici/prozoru. Pričekajte da se završi prije nego što nastavite ovdje.",
        "whatsapp.title": "Kontaktirajte nas putem WhatsApp-a",
        "whatsapp.instructions":
          "<bold>Kliknite</bold> ili <bold>Skenirajte</bold> da otvorite WhatsApp",
      },
    },
    sq: {
      translation: {
        legal:
          "Duke dërguar, pranoni <tosLink>kushtet tona të shërbimit</tosLink> dhe <ppLink>politikën tonë të privatësisë</ppLink>.",
        powered_by:
          "{{assistant_name}} mund të bëjë gabime. Fuqizuar nga <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Dërgoni një mesazh",
        "suggestions.toggle.show": "Shfaq sugjerime",
        "suggestions.toggle.hide": "Fshih sugjerimet",
        suggestions: "Sugjerime",
        assistant: "Asistent",
        thinking: "Duke menduar",
        understanding: "Duke kuptuar pyetjen",
        "handoff.success": "Transferimi i suksesshëm",
        "handoff.check_email": "Kontrolloni emailin tuaj",
        "handoff.anything_else": "A mund t'ju ndihmoj me diçka tjetër?",
        "handoff.rejected": "Transferimi u refuzua",
        "handoff.edit": "Ndrysho transferimin",
        "handoff.validation.firstName_required": "Emri është i detyrueshëm",
        "handoff.validation.lastName_required": "Mbiemri është i detyrueshëm",
        "handoff.validation.subject_required":
          "Përshkrimi i problemit është i detyrueshëm",
        "handoff.validation.body_required": "Detajet janë të detyrueshme",
        "handoff.validation.body_too_short":
          "Ju lutemi jepni informacion më të detajuar",
        "handoff.validation.email_required": "Emaili është i detyrueshëm",
        "handoff.validation.email_invalid":
          "Ju lutemi vendosni një adresë emaili të vlefshme",
        "handoff.form.issue_label": "Problemi",
        "handoff.form.details_label": "Detajet",
        "handoff.form.firstName_label": "Emri",
        "handoff.form.lastName_label": "Mbiemri",
        "handoff.form.email_label": "Emaili juaj",
        "handoff.form.firstName_placeholder": "Arben",
        "handoff.form.lastName_placeholder": "Hoxha",
        "handoff.form.email_placeholder": "arben@hoxha.al",
        "handoff.form.email_notice":
          "Do të merrni një kopje dhe do t'ju kontaktojmë së shpejti.",
        "handoff.error.title": "Gabim i serverit",
        "handoff.form.cancel_button": "Anulo",
        "handoff.form.send_button": "Dërgo",
        "handoff.form.sending_button": "Duke dërguar",
        "conversations.title": "Biseda",
        "conversations.noConversationsYet": "Ende ska biseda",
        "conversations.tapToStart":
          'Prek "Fillo bisedën" për të filluar ndërveprimin me asistentin AI',
        "conversations.startConversation": "Fillo bisedën",
        noConversationBranching:
          "Kjo bisedë është duke vazhduar në një kartelë/derë tjetër. Ju lutemi prisni që të përfundojë para se të vazhdoni këtu.",
        "whatsapp.title": "Na kontaktoni në WhatsApp",
        "whatsapp.instructions":
          "<bold>Klikoni</bold> ose <bold>Skani</bold> për të hapur WhatsApp",
      },
    },
    da: {
      translation: {
        legal:
          "Ved at sende, accepterer du vores <tosLink>servicevilkår</tosLink> og <ppLink>privatlivspolitik</ppLink>.",
        powered_by:
          "{{assistant_name}} kan lave fejl. Drevet af <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Send en besked",
        "suggestions.toggle.show": "Vis forslag",
        "suggestions.toggle.hide": "Skjul forslag",
        suggestions: "Forslag",
        assistant: "Assistent",
        thinking: "Tænker",
        understanding: "Forstår spørgsmålet",
        "handoff.success": "Overførsel vellykket",
        "handoff.check_email": "Tjek din e-mail",
        "handoff.anything_else": "Er der andet, jeg kan hjælpe med?",
        "handoff.rejected": "Overførsel afvist",
        "handoff.edit": "Rediger overførsel",
        "handoff.validation.firstName_required": "Fornavn er påkrævet",
        "handoff.validation.lastName_required": "Efternavn er påkrævet",
        "handoff.validation.subject_required": "Problembeskrivelse er påkrævet",
        "handoff.validation.body_required": "Detaljer er påkrævet",
        "handoff.validation.body_too_short":
          "Angiv venligst mere detaljerede oplysninger",
        "handoff.validation.email_required": "E-mail er påkrævet",
        "handoff.validation.email_invalid":
          "Indtast venligst en gyldig e-mailadresse",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detaljer",
        "handoff.form.firstName_label": "Fornavn",
        "handoff.form.lastName_label": "Efternavn",
        "handoff.form.email_label": "Din e-mail",
        "handoff.form.firstName_placeholder": "Anders",
        "handoff.form.lastName_placeholder": "Nielsen",
        "handoff.form.email_placeholder": "anders@nielsen.dk",
        "handoff.form.email_notice":
          "Du modtager en kopi, og vi vender tilbage snarest.",
        "handoff.error.title": "Serverfejl",
        "handoff.form.cancel_button": "Annuller",
        "handoff.form.send_button": "Send",
        "handoff.form.sending_button": "Sender",
        "conversations.title": "Samtaler",
        "conversations.noConversationsYet": "Ingen samtaler endnu",
        "conversations.tapToStart":
          'Tryk på "Start samtale" for at begynde at interagere med AI-assistenten',
        "conversations.startConversation": "Start samtale",
        noConversationBranching:
          "Denne samtale er allerede i gang i en anden fane/vindue. Vent på at den er færdig, før du fortsætter her.",
        "whatsapp.title": "Kontakt os på WhatsApp",
        "whatsapp.instructions":
          "<bold>Klik</bold> eller <bold>Scan</bold> for at åbne WhatsApp",
      },
    },
    fi: {
      translation: {
        legal:
          "Lähettämällä hyväksyt <tosLink>käyttöehtomme</tosLink> ja <ppLink>tietosuojakäytäntömme</ppLink>.",
        powered_by:
          "{{assistant_name}} saattaa tehdä virheitä. Toimii <botBrainsLink>botBrains</botBrainsLink>-teknologialla.",
        "prompt.placeholder": "Lähetä viesti",
        "suggestions.toggle.show": "Näytä ehdotukset",
        "suggestions.toggle.hide": "Piilota ehdotukset",
        suggestions: "Ehdotukset",
        assistant: "Avustaja",
        thinking: "Ajattelee",
        understanding: "Ymmärtää kysymyksen",
        "handoff.success": "Overførsel vellykket",
        "handoff.check_email": "Tjek din e-mail",
        "handoff.anything_else": "Er der andet, jeg kan hjælpe med?",
        "handoff.rejected": "Overførsel afvist",
        "handoff.edit": "Rediger overførsel",
        "handoff.validation.firstName_required": "Fornavn er påkrævet",
        "handoff.validation.lastName_required": "Efternavn er påkrævet",
        "handoff.validation.subject_required": "Problembeskrivelse er påkrævet",
        "handoff.validation.body_required": "Detaljer er påkrævet",
        "handoff.validation.body_too_short":
          "Angiv venligst mere detaljerede oplysninger",
        "handoff.validation.email_required": "E-mail er påkrævet",
        "handoff.validation.email_invalid":
          "Indtast venligst en gyldig e-mailadresse",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detaljer",
        "handoff.form.firstName_label": "Fornavn",
        "handoff.form.lastName_label": "Efternavn",
        "handoff.form.email_label": "Din e-mail",
        "handoff.form.firstName_placeholder": "Anders",
        "handoff.form.lastName_placeholder": "Nielsen",
        "handoff.form.email_placeholder": "anders@nielsen.dk",
        "handoff.form.email_notice":
          "Du modtager en kopi, og vi vender tilbage snarest.",
        "handoff.error.title": "Serverfejl",
        "handoff.form.cancel_button": "Annuller",
        "handoff.form.send_button": "Send",
        "handoff.form.sending_button": "Sender",
        "conversations.title": "Keskustelut",
        "conversations.noConversationsYet": "Ei vielä keskusteluja",
        "conversations.tapToStart":
          'Napauta "Aloita keskustelu" aloittaaksesi vuorovaikutuksen tekoälyavustajan kanssa',
        "conversations.startConversation": "Aloita keskustelu",
        noConversationBranching:
          "Tämä keskustelu on jo käynnissä toisessa välilehdessä/ikkunassa. Odota sen päättymistä ennen kuin jatkat täällä.",
        "whatsapp.title": "Ota meihin yhteyttä WhatsAppissa",
        "whatsapp.instructions":
          "<bold>Napsauta</bold> tai <bold>Skannaa</bold> avataksesi WhatsAppin",
      },
    },
    no: {
      translation: {
        legal:
          "Ved å sende godtar du våre <tosLink>vilkår for bruk</tosLink> og <ppLink>personvernregler</ppLink>.",
        powered_by:
          "{{assistant_name}} kan gjøre feil. Drevet av <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Send en melding",
        "suggestions.toggle.show": "Vis forslag",
        "suggestions.toggle.hide": "Skjul forslag",
        suggestions: "Forslag",
        assistant: "Assistent",
        thinking: "Tenker",
        understanding: "Forstår spørsmålet",
        "handoff.success": "Overføring vellykket",
        "handoff.check_email": "Sjekk e-posten din",
        "handoff.anything_else": "Er det noe annet jeg kan hjelpe deg med?",
        "handoff.rejected": "Overføring avvist",
        "handoff.edit": "Rediger overføring",
        "handoff.validation.firstName_required": "Fornavn er påkrevd",
        "handoff.validation.lastName_required": "Etternavn er påkrevd",
        "handoff.validation.subject_required": "Problembeskrivelse er påkrevd",
        "handoff.validation.body_required": "Detaljer er påkrevd",
        "handoff.validation.body_too_short":
          "Vennligst gi mer detaljert informasjon",
        "handoff.validation.email_required": "E-post er påkrevd",
        "handoff.validation.email_invalid":
          "Vennligst skriv inn en gyldig e-postadresse",
        "handoff.form.issue_label": "Problem",
        "handoff.form.details_label": "Detaljer",
        "handoff.form.firstName_label": "Fornavn",
        "handoff.form.lastName_label": "Etternavn",
        "handoff.form.email_label": "Din e-post",
        "handoff.form.firstName_placeholder": "Ole",
        "handoff.form.lastName_placeholder": "Hansen",
        "handoff.form.email_placeholder": "ole@hansen.no",
        "handoff.form.email_notice":
          "Du mottar en kopi og vi tar kontakt snart.",
        "handoff.error.title": "Serverfeil",
        "handoff.form.cancel_button": "Avbryt",
        "handoff.form.send_button": "Send",
        "handoff.form.sending_button": "Sender",
        "conversations.title": "Samtaler",
        "conversations.noConversationsYet": "Ingen samtaler ennå",
        "conversations.tapToStart":
          'Trykk på "Start samtale" for å begynne å samhandle med AI-assistenten',
        "conversations.startConversation": "Start samtale",
        noConversationBranching:
          "Denne samtalen pågår allerede i en annen fane/vindu. Vent til den er ferdig før du fortsetter her.",
        "whatsapp.title": "Kontakt oss på WhatsApp",
        "whatsapp.instructions":
          "<bold>Klikk</bold> eller <bold>Skann</bold> for å åpne WhatsApp",
      },
    },
    sk: {
      translation: {
        legal:
          "Odoslaním súhlasíte s našimi <tosLink>podmienkami používania</tosLink> a <ppLink>zásadami ochrany osobných údajov</ppLink>.",
        powered_by:
          "{{assistant_name}} môže robiť chyby. Poháňa ho <botBrainsLink>botBrains</botBrainsLink>.",
        "prompt.placeholder": "Poslať správu",
        "suggestions.toggle.show": "Zobraziť návrhy",
        "suggestions.toggle.hide": "Skryť návrhy",
        suggestions: "Návrhy",
        assistant: "Asistent",
        thinking: "Premýšľanie",
        understanding: "Porozumenie otázke",
        "handoff.success": "Prenos úspešný",
        "handoff.check_email": "Skontrolujte svoj email",
        "handoff.anything_else": "Môžem vám ešte s niečím pomôcť?",
        "handoff.rejected": "Prenos zamietnutý",
        "handoff.edit": "Upraviť prenos",
        "handoff.validation.firstName_required": "Meno je povinné",
        "handoff.validation.lastName_required": "Priezvisko je povinné",
        "handoff.validation.subject_required": "Popis problému je povinný",
        "handoff.validation.body_required": "Podrobnosti sú povinné",
        "handoff.validation.body_too_short":
          "Prosím, poskytnite podrobnejšie informácie",
        "handoff.validation.email_required": "Email je povinný",
        "handoff.validation.email_invalid":
          "Prosím, zadajte platnú emailovú adresu",
        "handoff.form.issue_label": "Problém",
        "handoff.form.details_label": "Podrobnosti",
        "handoff.form.firstName_label": "Meno",
        "handoff.form.lastName_label": "Priezvisko",
        "handoff.form.email_label": "Váš email",
        "handoff.form.firstName_placeholder": "Peter",
        "handoff.form.lastName_placeholder": "Novák",
        "handoff.form.email_placeholder": "peter@novak.sk",
        "handoff.form.email_notice":
          "Dostanete kópiu a čoskoro vás budeme kontaktovať.",
        "handoff.error.title": "Chyba servera",
        "handoff.form.cancel_button": "Zrušiť",
        "handoff.form.send_button": "Odoslať",
        "handoff.form.sending_button": "Odosiela sa",
        "conversations.title": "Konverzácie",
        "conversations.noConversationsYet": "Zatiaľ žiadne konverzácie",
        "conversations.tapToStart":
          'Ťuknite na "Začať konverzáciu" pre začatie interakcie s AI asistentom',
        "conversations.startConversation": "Začať konverzáciu",
        noConversationBranching:
          "Táto konverzácia už prebieha na inej karte/okne. Počkajte na jej ukončenie, než budete pokračovať tu.",
      },
    },
    zh: {
      translation: {
        legal:
          "提交即表示您同意我们的 <tosLink>服务条款</tosLink> 和 <ppLink>隐私政策</ppLink>。",
        powered_by:
          "{{assistant_name}} 可能会出错。由 <botBrainsLink>botBrains</botBrainsLink> 提供支持。",
        "prompt.placeholder": "发送消息",
        "suggestions.toggle.show": "显示建议",
        "suggestions.toggle.hide": "隐藏建议",
        suggestions: "建议",
        assistant: "助手",
        thinking: "思考中",
        understanding: "理解请求",
        "handoff.success": "转接成功",
        "handoff.check_email": "检查您的电子邮件",
        "handoff.anything_else": "还有什么可以帮助您的吗？",
        "handoff.rejected": "转接被拒绝",
        "handoff.edit": "编辑转接",
        "handoff.validation.firstName_required": "名字是必填项",
        "handoff.validation.lastName_required": "姓氏是必填项",
        "handoff.validation.subject_required": "问题描述是必填项",
        "handoff.validation.body_required": "详细信息是必填项",
        "handoff.validation.body_too_short": "请提供更详细的信息",
        "handoff.validation.email_required": "电子邮件是必填项",
        "handoff.validation.email_invalid": "请输入有效的电子邮件地址",
        "handoff.form.issue_label": "问题",
        "handoff.form.details_label": "详细信息",
        "handoff.form.firstName_label": "名字",
        "handoff.form.lastName_label": "姓氏",
        "handoff.form.email_label": "您的电子邮件",
        "handoff.form.firstName_placeholder": "张",
        "handoff.form.lastName_placeholder": "三",
        "handoff.form.email_placeholder": "zhangsan@example.com",
        "handoff.form.email_notice": "您会收到一份副本，我们会尽快跟进。",
        "handoff.error.title": "后台错误",
        "handoff.form.cancel_button": "取消",
        "handoff.form.send_button": "发送",
        "handoff.form.sending_button": "发送中",
        "conversations.title": "对话",
        "conversations.noConversationsYet": "暂无对话",
        "conversations.tapToStart": "点击“开始对话”以与 AI 助手互动",
        "conversations.startConversation": "开始对话",
        noConversationBranching:
          "此对话已在另一个标签/窗口中进行。请等待完成后再继续。",
        "whatsapp.title": "通过 WhatsApp 联系我们",
        "whatsapp.instructions":
          "<bold>点击</bold> 或 <bold>扫描</bold> 打开 WhatsApp",
      },
    },
    hi: {
      translation: {
        legal:
          "सबमिट करने पर, आप हमारी <tosLink>सेवा की शर्तों</tosLink> और <ppLink>गोपनीयता नीति</ppLink> से सहमत होते हैं।",
        powered_by:
          "{{assistant_name}} गलतियाँ कर सकता है। <botBrainsLink>botBrains</botBrainsLink> द्वारा संचालित।",
        "prompt.placeholder": "संदेश भेजें",
        "suggestions.toggle.show": "सुझाव दिखाएं",
        "suggestions.toggle.hide": "सुझाव छिपाएं",
        suggestions: "सुझाव",
        assistant: "सहायक",
        thinking: "सोच रहा है",
        understanding: "समझने की कोशिश कर रहा है",
        "handoff.success": "हस्तांतरण सफल हुआ",
        "handoff.check_email": "अपना ईमेल जाँचें",
        "handoff.anything_else":
          "क्या मैं आपकी किसी और चीज़ में सहायता कर सकता हूँ?",
        "handoff.rejected": "हस्तांतरण अस्वीकार किया गया",
        "handoff.edit": "हस्तांतरण संपादित करें",
        "handoff.validation.firstName_required": "पहला नाम आवश्यक है",
        "handoff.validation.lastName_required": "अंतिम नाम आवश्यक है",
        "handoff.validation.subject_required": "समस्या विवरण आवश्यक है",
        "handoff.validation.body_required": "विवरण आवश्यक है",
        "handoff.validation.body_too_short":
          "कृपया अधिक विस्तृत जानकारी प्रदान करें",
        "handoff.validation.email_required": "ईमेल आवश्यक है",
        "handoff.validation.email_invalid": "कृपया एक मान्य ईमेल पता दर्ज करें",
        "handoff.form.issue_label": "समस्या",
        "handoff.form.details_label": "विवरण",
        "handoff.form.firstName_label": "पहला नाम",
        "handoff.form.lastName_label": "अंतिम नाम",
        "handoff.form.email_label": "आपका ईमेल",
        "handoff.form.firstName_placeholder": "राज",
        "handoff.form.lastName_placeholder": "कुमार",
        "handoff.form.email_placeholder": "raj@example.com",
        "handoff.form.email_notice":
          "आपको एक प्रति प्राप्त होगी और हम शीघ्र ही संपर्क करेंगे।",
        "handoff.error.title": "बैकएंड त्रुटि",
        "handoff.form.cancel_button": "रद्द करें",
        "handoff.form.send_button": "भेजें",
        "handoff.form.sending_button": "भेजा जा रहा है",
        "conversations.title": "संवाद",
        "conversations.noConversationsYet": "अभी तक कोई संवाद नहीं",
        "conversations.tapToStart":
          "AI सहायक के साथ बातचीत शुरू करने के लिए 'संवाद प्रारंभ करें' टैप करें",
        "conversations.startConversation": "संवाद प्रारंभ करें",
        noConversationBranching:
          "यह संवाद पहले से ही दूसरे टैब/विंडो में चल रहा है। कृपया पहले इसे समाप्त होने दें।",
        "whatsapp.title": "व्हाट्सएप पर हमसे संपर्क करें",
        "whatsapp.instructions":
          "<bold>क्लिक करें</bold> या <bold>स्कैन करें</bold> व्हाट्सएप खोलने के लिए",
      },
    },
  },
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(i18nOptions);

export default i18n;
